/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row1_LinearInputs */

const en_mk_cmp_row1_linear = /** @type {(inputs: Mk_Cmp_Row1_LinearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Third-party agents, dev-focused`)
};

const id_mk_cmp_row1_linear = /** @type {(inputs: Mk_Cmp_Row1_LinearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen pihak ketiga, terbatas dev`)
};

/**
* | output |
* | --- |
* | "Third-party agents, dev-focused" |
*
* @param {Mk_Cmp_Row1_LinearInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row1_linear = /** @type {((inputs?: Mk_Cmp_Row1_LinearInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row1_LinearInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row1_linear(inputs)
	return en_mk_cmp_row1_linear(inputs)
});